import React from 'react';

function slider() {
  return (
      <section id="section-slider" className="fullwidthbanner-container" aria-label="section-slider">
          <div id="revolution-slider">
            <ul>
              <li data-transition="fade" data-slotamount="10" data-masterspeed="default" data-thumb="">
                
                <img src="assets/images-slider/slider11.jpg" alt="" data-bgposition="center center" data-kenburns="on" data-duration="12000" data-ease="Linear.easeNone" data-scalestart="100" data-scaleend="120" data-rotatestart="0" data-rotateend="0" data-offsetstart="0 0" data-offsetend="0 0" data-bgparallax="10" />
                <div className="tp-caption big-white"
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['-80']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="400">
                    <span className="id-color slidertextfont" style={{fontSize: '14px',fontWeight: '800' }} >Our Expertise For</span>
                </div>
                <div className="tp-caption ultra-big-white customin customout start"
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['0']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="600"
                    data-end="2600" style={{fontSize:'60px'}} >
                    Lightning Protection System
                </div>
                <div className=" tp-caption ultra-big-white customin customout start "
                    data-x="center"
                    data-y="center"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="2600 " style={{fontSize:'60px'}} >
                    Earthing System
                </div>

                  
              </li>

              <li data-transition="fade" data-slotamount="10" data-masterspeed="default" data-thumb="">
                  
                <img src="assets/images-slider/slider12.jpg" alt="" data-bgposition="center center" data-kenburns="on" data-duration="12000" data-ease="Linear.easeNone" data-scalestart="100" data-scaleend="120" data-rotatestart="0" data-rotateend="0" data-offsetstart="0 0" data-offsetend="0 0" data-bgparallax="10" />
                <div className="tp-caption big-white"
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['-80']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="400">
                    <span className="id-color slidertextfont" style={{fontSize: '14px',fontWeight: '800' }} >Our Expertise For</span>
                </div>

                <div className=" tp-caption ultra-big-white customin customout start "
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['0']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="600" style={{fontSize:'60px'}} >
                    Energy Monitoring
                </div>

                  
              </li>

              <li data-transition="fade" data-slotamount="10" data-masterspeed="default" data-thumb="">
                  
                <img src="assets/images-slider/slider13.jpg" alt="" data-bgposition="center center" data-kenburns="on" data-duration="12000" data-ease="Linear.easeNone" data-scalestart="100" data-scaleend="120" data-rotatestart="0" data-rotateend="0" data-offsetstart="0 0" data-offsetend="0 0" data-bgparallax="10" />
                <div className="tp-caption big-white"
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['-80']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="400">
                    <span className="id-color slidertextfont" style={{fontSize: '14px',fontWeight: '800' }} >Our Expertise For</span>
                </div>

                <div className=" tp-caption ultra-big-white customin customout start "
                    data-x="['center']" data-hoffset="['0']"
                    data-y="['middle']" data-voffset="['0']"
                    data-width="none"
                    data-height="none"
                    data-whitespace="nowrap"
                    data-transform_in="opacity:0;scaleX:2;scaleY:2;s:400;e:Power3.easeOut;"
                    data-transform_out="opacity:0;s:400;e:Power3.easeOut;"
                    data-start="600" style={{fontSize:'60px'}} >
                    Solar Solutions
                </div>

                  
              </li>

              </ul>
          </div>
      </section>
  );
}

export default slider;
